import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { ButtonTheme, TagTheme, ToggleSwitchStatus, IconPosition } from '@fcom/ui-components';
import { Category, SubCategory } from '@fcom/dapi/api/models';
import { getIconForServiceCategory } from '@fcom/dapi/utils';
import { Amount } from '@fcom/dapi/interfaces';

@Component({
  selector: 'fin-bundle-selected-toggle',
  templateUrl: './bundle-selected-toggle.component.html',
  styleUrls: ['./bundle-selected-toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BundleSelectedToggleComponent {
  readonly SvgLibraryIcon = SvgLibraryIcon;
  readonly IconPosition = IconPosition;
  readonly TagTheme = TagTheme;
  readonly ToggleSwitchStatus = ToggleSwitchStatus;
  readonly ButtonTheme = ButtonTheme;

  @Input({ required: true })
  active: boolean;

  @Input()
  bundleUpsellPrice: Amount | undefined;

  @Input({ required: true })
  category: Category;

  @Input({ required: true })
  subCategoryForTranslations: SubCategory;

  @Output()
  bundleSelectedToggled: EventEmitter<boolean> = new EventEmitter();

  emitToggle(toggled: boolean): void {
    this.bundleSelectedToggled.emit(toggled);
  }

  protected readonly getIconForServiceCategory = getIconForServiceCategory;
  protected readonly Category = Category;
}
